import { ViewFactory } from 'cube-react'

import { MainScope } from '../main.scope'
import MainView from './v-main'

import { AlertScope } from '../main.scope'
import AlertView from './v-alert'

import { DialogScope } from '../main.scope'
import DialogView from './v-dialog'

import { HomeScope } from '../main.scope'
import HomeView from './v-home'

export { MainView }

export function registerViews(rr: typeof ViewFactory['register']) {
    rr(MainScope, MainView)
    rr(HomeScope, HomeView)
    rr(AlertScope, AlertView)
    rr(DialogScope, DialogView)
}